import { Card, Container, Grid, Table, Text } from '@nextui-org/react';
import axios from 'axios';
import React,{ useState,useEffect } from 'react';
import { Col, FlexboxGrid, IconButton, Pagination, Panel, Row } from 'rsuite';
import { WorkshopPublicURL } from '../../../apis/urls';
import { $ } from "react-jquery-plugin";
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { decode } from 'html-entities';

const ListRegisterEvent =()=> {


    const navigation = useNavigate();

    const [result, setResult] = useState([]);
    const [activePage, setActivePage] = React.useState(1);

    useEffect(()=>{
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        $('body').removeClass('').addClass('sidebar-collapsed');
        publicEventListing();

    },[])



    const publicEventListing = () => {

        const instance = axios.create({
            baseURL: WorkshopPublicURL+"/public/event",
            timeout: 1000000,
        });
        instance.get('').then((response) =>{
            setResult(response.data.data)
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
    }



    let slno = 1;

    const publicReg =(ids)=>{
        navigation('/public_registration/'+ids)
        console.log("aaa")
    }



    const search = useLocation().search;

    const id=new URLSearchParams(search).get("event");

  return (

    <div>

      asas
      <h1>{id}</h1>

     </div>

          
  );
}


export default ListRegisterEvent;